import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@root/services/auth-guard.service';
import { OrderComponent } from './order/order.component';
import { OrdersComponent } from './orders/orders.component';
import { PaypalOrdersComponent } from './paypal-orders/paypal-orders.component';
import { PTOOrdersComponent } from './pto-orders/pto-orders.component';
import { StripeOrdersComponent } from './stripe-orders/stripe-orders.component';
import { TopupVtComponent } from './topup-vt/topup-vt.component';
import { VcardTrnxComponent } from './vcard-trnx/vcard-trnx.component';
import {worldnetComponent} from './worldnet/worldnet-orders.component'
import { SamerchantTrxnsComponent } from '../dashboard/components/samerchant-trxns/samerchant-trxns.component';

const routes: Routes = [
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [AuthGuardService],
},
{
  path: 'topup',
  component: TopupVtComponent,
  canActivate: [AuthGuardService],
},
  {
    path: 'ptorders',
    component: PTOOrdersComponent,
    canActivate: [AuthGuardService],
},
{
  path: 'paypalorders',
  component: PaypalOrdersComponent,
  canActivate: [AuthGuardService],
},
{
  path: 'vcardTransaction',
  component: VcardTrnxComponent,
  canActivate: [AuthGuardService],
},
{
  path: 'stripeorders',
  component: StripeOrdersComponent,
  canActivate: [AuthGuardService],
},
{
  path: 'worldnetOrders',
  component: worldnetComponent,
  canActivate: [AuthGuardService],
},
  {
    path: 'transaction',
    component: OrderComponent,
    canActivate: [AuthGuardService],
},
{
  path:'transaction/:id',
  component : OrderComponent,
  canActivate: [AuthGuardService],
},
{
  path:'salesagent-transaction/:id',
  component : SamerchantTrxnsComponent,
  canActivate: [AuthGuardService],
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LunexRoutingModule { }
